//package imports
import React, { useEffect, useState, useRef } from "react";
import SupportModal from "./SupportModal";
import EmailVerificationModal from "./EmailVerificationModal";
import OtpInput from 'react-otp-input';

import Modal from 'react-bootstrap/Modal';
import osanLogo from "../../assests/images/osan_logo.webp"
import Button from 'react-bootstrap/Button';
import { showToast } from "../constants/Toaster";


const CustomModal = (props) => {
  const { imgvalue, close, open, modalTitle, Action, image, height, from, Continue, modalContent, emailAction ,resendOtp,RejectAction,notifytime,statusCheck,type} = props;
  const [otp, setOtp] = useState('');
  const [disableButton, setDIsabledButton] = useState(false)
  const [errorMessage,setErrorMessage]=useState("")
  const [reason,setReason]=useState("")
  const initialTime = 2 * 60 * 1000;
  const [time, setTime] = useState(initialTime) 
  const modalRef = useRef();

  
  useEffect(() => {
     setReason("")
  }, [RejectAction]);

  //function for handle modal backDrop Click
  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      // Handle the click outside the modal (e.g., prevent closing the modal)
      e.preventDefault();
      e.stopPropagation();
    }
  };

  //useEffect function to handle otp function
  useEffect(() => {
    if (otp != "") {
      setErrorMessage("")
      setDIsabledButton(false)
    } 
  }, [otp]);

  //useEffect function to handle resend otp timer
  useEffect(() => {
    let timer
    if(from === "EmailModal"){
       timer = setInterval(() => {
        // Decrement time every millisecond
        setTime(prevTime => Math.max(prevTime - 1000, 0)); // Decrease by 10 milliseconds
      }, 1000);
    }
    // Cleanup the interval when the component unmounts
    return () => clearInterval(timer);
  }, [resendOtp]);


//functional validation for email otp handling
  const handleOtp = (otp) => {
    if (otp === "") {
      setErrorMessage("Please enter OTP")
      setDIsabledButton(true)
    }else if(otp.length != 4){
      setErrorMessage("Please enter valid OTP!")
      setDIsabledButton(true)
    } 
    else {
      setErrorMessage("")
      emailAction(otp)
    }

  }
  
  
  const handleReason = (e) => {
    let reasonValue = e.target.value;
    if (reasonValue.length === 1 && reasonValue[0] === ' ') {
     setReason("");
   }else{
    setReason(reasonValue)
   }
  }

  //fucntion call to reject modal
  const handleReject = () => {
    if(reason.length < 3 ){
      showToast(3,"Please enter minimum 3 characters")
    }else{
      RejectAction(reason)
    }
  }


  const formatTime = (timeInMilliseconds) => {
    const minutes = Math.floor(timeInMilliseconds / (60 * 1000));
const seconds = Math.floor((timeInMilliseconds % (60 * 1000)) / 1000);
const formatSeconds = seconds < 10 ? `0${seconds}` : seconds
return `0${minutes}:${formatSeconds}`;
  };

   //function to handle resend button 
   const handleResendButton = async () => {
      setTime(initialTime)
      resendOtp()
}


  const buttonStyle = {
    backgroundColor: "#0A2FB6", // Set your desired background color
    color: 'white', // Set the text color if needed
  };

  const logOutButton = {
    backgroundColor: "#0A2FB6", // Set your desired background color
    color: 'white', // Set the text color if needed
    width:"80px"
  }



  return (
    <Modal show={open} onHide={close} aria-labelledby="contained-modal-title-vcenter"
      centered size={from === "SupportModal" ? "lg" : "md"} backdrop="static" onClick={imgvalue != undefined ? null : handleBackdropClick}  >
      {
        imgvalue !== undefined ?
          <div>
            
            <Modal.Header style={{borderBottom:"0px",paddingBottom:"0px"}}   closeButton>
              { from ==="client" ?<img src={osanLogo} /> : null}
            </Modal.Header>
            {
              from ==="client" ? null : 
              <div class="d-flex w-100 h-100 justify-content-center align-items-center">
              <img src={imgvalue} class="img-fluid mb-4 " alt="previewImg" />
            </div>
            }
            {
              from ==="client" ? <Modal.Body>
              <h4 class="fs-6 text-left mx-2"> {modalTitle} </h4>
              <h6>{notifytime}</h6>
              </Modal.Body>  :null
            }
           
            
          </div>
          :
          <div style={{ height: `${height}`, borderRadius: "24px" }} class="mt-4">
            <Modal.Body>
              {
                from === undefined ?
                  <>
                    <h2 class="fs-5 text-center mx-2"> {modalTitle} </h2>
                    <h2 class="fs-5 text-center mx-2"> {modalContent} </h2>
                  </>
                  :
                  from === "SupportModal" ? <SupportModal /> : <EmailVerificationModal />
              }{
                RejectAction  ?  <div class="mb-4 d-flex justify-content-center align-items-center " >
                  <div class="w-75 my-2">
                      <input class="form-control form-control-lg" type="text" name="Reason" placeholder="Enter the reason" value={reason} aria-label="default input example" onChange={(e) => {handleReason(e)}} maxLength={200}></input>
                      </div>
                  </div> : null
                
              }
              {
                from === undefined ?
                  ""
                  :
                  from === "SupportModal" ?
                    ""
                    :
                    <div class="col-md-12 d-flex flex-column justify-content-center align-items-center my-2 "  >
                      <div>
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          inputType="number"
                          numInputs={4}
                          renderSeparator={<span class="mx-3"></span>}
                          renderInput={(props) => <input {...props} />}
                          inputStyle={{
                            width: '46px',
                            height: "40px",
                            borderRadius: "8px",
                            borderStyle: 'solid'

                          }}
                        />
                      </div>
                      <div class="align-self-center my-2">
                        <p class="m-0">{formatTime(time)}</p>
                        </div>
                        {
                         time === 0 ? 
                         <div class="mx-4 my-1 align-self-center">
                         <p clas="paraColor Roboto-regular fs-2 m-0" >Didn’t receive code?  <span class="text-primary cursorPointer" onClick={() => handleResendButton()} >Resend</span></p>
                     </div> :
                     null
                        }
                      {
                        errorMessage != "" ?
                         <div class="my-2">
                          <h6 class="text-danger">{errorMessage}</h6> 
                          </div>
                         : null
                      }
                    </div>
                    
              }
            </Modal.Body>
            {
              RejectAction ?
              <Modal.Footer class="d-flex justify-content-around align-self-center">
              
                <div class="d-flex justify-content-around w-50 mb-5 mt-2">
                <Button onClick={() => handleReject()} style={logOutButton} disabled={from != undefined ? disableButton : false}>
                    {"Yes"}
                  </Button>
                  <Button onClick={close} style={logOutButton} >
                    {"No"}
                  </Button>
                </div>
              
            </Modal.Footer> :
 <Modal.Footer class="d-flex justify-content-around align-self-center">
 {from === "SupportModal" ?
   <div class="d-flex justify-content-around w-50 mt-4">
     <Button className="px-5 py-2" onClick={Continue} style={buttonStyle}>
       Continue
     </Button>
   </div> :
   <div class="d-flex justify-content-around w-50 mb-5 mt-2">
   <Button onClick={from != undefined ? () => handleOtp(otp) : RejectAction? handleReject(): Action} style={logOutButton} disabled={from != undefined ? disableButton : false}>
       {from != undefined ? "Verify" : "Yes"}
     </Button>
     <Button onClick={close} style={logOutButton} >
       {from != undefined ? "Skip" : "No"}
     </Button>
   </div>
 }
</Modal.Footer>
            }
           
          </div>
      }

    </Modal>
  )
}

export default CustomModal